import { Component, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router, Event, NavigationEnd, RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import translationsDE from '../../public/i18n/de.json';
import translationsEN from '../../public/i18n/en.json';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet],
    templateUrl: './app.component.html',
})
export class AppComponent {
    private router: Router = inject(Router);
    private translate: TranslateService = inject(TranslateService);
    private platformId = inject(PLATFORM_ID);
    private enhancementsLoaded = false;

    ngOnInit(): void {
        this.translate.setTranslation('de', translationsDE);
        this.translate.setTranslation('en', translationsEN);
        this.translate.use('de');

        if (isPlatformBrowser(this.platformId)) {
            this.router.events.subscribe((event: Event) => {
                if (event instanceof NavigationEnd) {
                    this.loadContentEnhancements(event.urlAfterRedirects);
                }
            });
        }
    }

    private loadContentEnhancements(url: string): void {
        if (!/^\/(de|en)\/(apartment|hof)(\/|$)/.test(url)) return;

        setTimeout(async () => {
            const [collapseModule, overlayModule, aosModule] =
                await Promise.all([
                    import('preline/plugins/collapse-non-auto'),
                    import('preline/plugins/overlay-non-auto'),
                    import('aos'),
                ]);
            collapseModule.default.autoInit();
            overlayModule.default.autoInit();

            const aos = aosModule.default ?? aosModule;
            if (this.enhancementsLoaded) {
                aos?.refresh?.();
                return;
            }
            aos?.init?.({ once: true });
            this.enhancementsLoaded = true;
        });
    }
}
